import type {IntlShape} from 'react-intl';
import {formatDuration, formatHours} from '../../../forecast-app/admin-tab/templates-page/baseline/baselineTemplateFormat';

type DataLineRow = {
	phaseCount: number | null;
	totalMinutes: number | null;
	roleCount: number | null;
	durationDays: number | null;
	includeDeliverables: boolean | null;
	deliverableCount: number | null;
};

const SEPARATOR = ' · ';

/** "2 phases · 45h · 4 roles · 59 days · 12 weeks · 2 deliverables"; deliverables only when both sides use them. */
export const formatDataLine = (intl: IntlShape, row: DataLineRow, projectUsesDeliverables: boolean): string => {
	const parts = [
		intl.formatMessage({id: 'baseline_templates.insert.data.phases'}, {count: row.phaseCount ?? 0}),
		formatHours(intl, row.totalMinutes ?? 0),
		intl.formatMessage({id: 'baseline_templates.insert.data.roles'}, {count: row.roleCount ?? 0}),
		formatDuration(intl, row.durationDays ?? 0),
	];
	if (projectUsesDeliverables && row.includeDeliverables && (row.deliverableCount ?? 0) > 0) {
		parts.push(intl.formatMessage({id: 'baseline_templates.insert.data.deliverables'}, {count: row.deliverableCount}));
	}
	return parts.join(SEPARATOR);
};

type PreviewNoteInput = {
	includeDeliverables: boolean | null;
	deliverableCount: number | null;
	phases: ReadonlyArray<{deliverableName: string | null} | null>;
};

/** The preview's info box: the rates and dates note, then what happens to deliverables on this project. */
export const previewNotes = (intl: IntlShape, preview: PreviewNoteInput, projectUsesDeliverables: boolean): string[] => {
	const notes = [intl.formatMessage({id: 'baseline_templates.insert.preview.note'})];
	const templateDeliverables = preview.includeDeliverables ? preview.deliverableCount ?? 0 : 0;
	if (!projectUsesDeliverables && templateDeliverables > 0) {
		notes.push(
			intl.formatMessage(
				{id: 'baseline_templates.insert.preview.note_deliverables_skipped'},
				{count: templateDeliverables}
			)
		);
	}
	const phaseWithoutDeliverable = preview.phases.some(phase => !preview.includeDeliverables || !phase?.deliverableName);
	if (projectUsesDeliverables && phaseWithoutDeliverable) {
		notes.push(intl.formatMessage({id: 'baseline_templates.insert.preview.note_deliverables_added'}));
	}
	return notes;
};
